<template>
  <v-container fluid>
    <v-row dense>
      <v-col>
        <v-radio-group
            dense
            v-model="supply_list.up_level.default_supply"
            row
            @change="updateValue()"
            :label="$t('default_supply')"
            class="mb-n2"
        >
          <v-radio v-if="supply_list.up_level.tape_supply_enable" value="Tape and reel" label="Tape reel"
                   dense></v-radio>
          <v-radio v-if="supply_list.up_level.tray_supply_enable" value="Tray" label="Tray" dense></v-radio>
          <v-radio v-if="supply_list.up_level.stick_supply_enable" value="Stick" label="Stick" dense></v-radio>
          <v-radio v-if="supply_list.up_level.bulk_supply_enable" value="Bulk" label="Bulk" dense></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="3">
        <ComponentMsdSelect
            v-if="supplyRecommendation"
            v-model="supply_list.up_level.msd_level"
            :label="$t('msd_level_recommendation')"
            class="mt-3"
            @input="updateValue()"
        ></ComponentMsdSelect>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-card>
          <v-system-bar class="mb-3">
            <v-checkbox
                v-model="supply_list.up_level.tape_supply_enable"
                @change="updateValue()"
                class="mt-4"
            ></v-checkbox>
            Tape reel
          </v-system-bar>
          <v-sheet v-if="supply_list.up_level.tape_supply_enable" class="overflow-y-auto px-3 py-3">
            <CommonFieldSelect v-model="supply_list.tape_supply.tape_kind_id"
                               label="Tape kind"
                               class="mb-n3"
                               :items="[
                                {text: 'Paper', value: 1},
                                {text: 'Embossed', value:2},
                                {text: 'Adhesive', value: 3},
                                ]"
                               :clearable="!master_norm.up_level.tape_supply_enable || !master_norm.tape_supply.tape_kind_id"
                               item-text="text"
                               item-value="value"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tape_supply_enable && !!master_norm.tape_supply.tape_kind_id"
            ></CommonFieldSelect>
            <CommonFieldSelect v-model="supply_list.tape_supply.tape_width"
                               label="Tape width"
                               class="mb-n3"
                               :items="[4, 8, 12, 16, 24, 32, 44, 56, 72, 88, 104, 120]"
                               :clearable="!master_norm.up_level.tape_supply_enable || !master_norm.tape_supply.tape_width"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tape_supply_enable && !!master_norm.tape_supply.tape_width"
            ></CommonFieldSelect>
            <CommonFieldSelect v-model="supply_list.tape_supply.feed_pitch"
                               label="Tape pitch"
                               class="mb-n3"
                               :items="[1, 2, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76]"
                               :clearable="!master_norm.up_level.tape_supply_enable || !master_norm.tape_supply.feed_pitch"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tape_supply_enable && !!master_norm.tape_supply.feed_pitch"
            ></CommonFieldSelect>
            <CommonFieldSelect v-model="supply_list.tape_supply.reel_size"
                               label="Reel size"
                               class="mb-n3"
                               :items="[
                                {text: 'Large', value: 1},
                                {text: 'Small', value:2},
                                ]"
                               :clearable="!master_norm.up_level.tape_supply_enable || !master_norm.tape_supply.reel_size"
                               item-text="text"
                               item-value="value"
                               dense
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tape_supply_enable && !!master_norm.tape_supply.reel_size"
            ></CommonFieldSelect>
          </v-sheet>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-system-bar class="mb-3">
            <v-checkbox
                v-model="supply_list.up_level.tray_supply_enable"
                dense
                @change="updateValue"
                class="mt-4"
            ></v-checkbox>
            Tray
          </v-system-bar>
          <v-sheet v-if="supply_list.up_level.tray_supply_enable" class="overflow-y-auto px-3 py-3">
            <CommonFieldNumber v-model="supply_list.tray_supply.tray_overall_x"
                               label="Tray Overall X"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.tray_overall_x"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.tray_overall_y"
                               label="Tray Overall Y"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.tray_overall_y"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.tray_overall_height"
                               label="Tray Overall Height"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.tray_overall_height"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.first_pickup_x"
                               label="First Pickup X"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.first_pickup_x"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.first_pickup_y"
                               label="First Pickup Y"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.first_pickup_y"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.last_pickup_x"
                               label="Last Pickup X"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.last_pickup_x"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.last_pickup_y"
                               label="Last Pickup Y"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.last_pickup_y"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.tray_pickup_height"
                               label="Tray Pickup Height"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.tray_pickup_height"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.pocket_count_x"
                               label="Pocket count X"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.pocket_count_x"
            ></CommonFieldNumber>
            <CommonFieldNumber v-model="supply_list.tray_supply.pocket_count_y"
                               label="Pocket count Y"
                               class="mb-n3"
                               :clearable="false"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.tray_supply_enable && !!master_norm.tray_supply.pocket_count_y"
            ></CommonFieldNumber>
          </v-sheet>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-system-bar class="mb-3">
            <v-checkbox
                v-model="supply_list.up_level.stick_supply_enable"
                dense
                @change="updateValue"
                class="mt-4"
            ></v-checkbox>
            Stick
          </v-system-bar>
          <v-sheet v-if="supply_list.up_level.stick_supply_enable" class="overflow-y-auto px-3 py-3">
            <CommonFieldSelect v-model="supply_list.stick_supply.stick_width"
                               :items="[
                      {text: '28 < Ws <= 34', value: 1},
                      {text: '19 < Ws <= 28', value: 2},
                      {text: 'Ws <= 19', value: 3},
                      ]"
                               :clearable="!master_norm.up_level.stick_supply_enable || !master_norm.stick_supply.stick_width"
                               item-text="text"
                               item-value="value"
                               dense
                               label="Stick Width"
                               class="mb-n3"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.stick_supply_enable && !!master_norm.stick_supply.stick_width"
            ></CommonFieldSelect>
            <CommonFieldSelect v-model="supply_list.stick_supply.stick_height"
                               :items="[
                      {text: 'Hs <= 7', value: 1},
                      {text: '7 < Hs <= 14', value: 2},
                      {text: '14 < Hs <= 21', value: 3},
                      {text: '21 < Hs <= 28', value: 4},
                      ]"
                               :clearable="!master_norm.up_level.stick_supply_enable || !master_norm.stick_supply.stick_height"
                               item-text="text"
                               item-value="value"
                               dense
                               label="Stick Height"
                               class="mb-n3"
                               @input="updateValue"
                               :readonly="!!master_norm.up_level.stick_supply_enable && !!master_norm.stick_supply.stick_height"
            ></CommonFieldSelect>
          </v-sheet>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-system-bar class="mb-3">
            <v-checkbox
                v-model="supply_list.up_level.bulk_supply_enable"
                dense
                @change="updateValue"
                class="mt-4"
            ></v-checkbox>
            Bulk
          </v-system-bar>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonFieldSelect from "@/components/Common/CommonFieldSelect";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import CommonFieldText from "@/components/Common/CommonFieldText";
import CommonFieldString from "@/components/Common/CommonFieldString";
import ComponentMsdSelect from "@/components/CoreComponent/Component/ComponentMsdSelect";
import CommonFieldCheck from "@/components/Common/CommonFieldCheck";

export default {
  name: "CoreCasePackageSupplyDefault",

  props: {
    storeName: {type: [String], default: 'storeCoreCasePackageSupplyDefault'},
    value: {
      default: function () {
        return {
          tape_supply: {},
          tray_supply: {},
          stick_supply: {},
        }
      },
    },
    masterSupplyInformation: {default: null,},
    height: {default: 550},
    supplyRecommendation: {default: true},
  },

  components: {
    CommonFieldCheck,
    ComponentMsdSelect,
    CommonFieldText,
    CommonFieldSelect,
    CommonFieldNumber,
    CommonFieldString,
  },

  computed: {
    master_norm() {
        return this.masterSupplyInformation || {
          up_level: {},
          tape_supply: {},
          tray_supply: {},
          stick_supply: {},
        }
    },

  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        this.supply_list = newValue
      },
      deep: true
    },
  },

  methods: {
    setDefaultTape() {
      console.log('setDefaultTape')
      this.supply_list.tape_supply.set_default = true
      this.$emit('input', structuredClone(this.supply_list))
    },
    setDefaultTray() {
      console.log('setDefaultTray')
      this.supply_list.tray_supply.set_default = true
      this.$emit('input', structuredClone(this.supply_list))
    },
    updateValue() {
      // console.log('updateValue', structuredClone(this.supply_list))
      this.$emit('input', structuredClone(this.supply_list))
    },
  },

  async mounted() {
  },

  data() {
    return {
      supply_list: this.value,
    }
  }
}

</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>